function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function t(e, t, r) {
  return t = i(t), function (e, t) {
    if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e);
  }(e, l() ? Reflect.construct(t, r || [], i(e).constructor) : t.apply(e, r));
}
function r(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function n(e, t, r) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function o(t, r) {
  var _n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (!_n) {
    if (Array.isArray(t) || (_n = function (t, r) {
      if (t) {
        if ("string" == typeof t) return e(t, r);
        var n = {}.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? e(t, r) : void 0;
      }
    }(t)) || r) {
      _n && (t = _n);
      var o = 0,
        a = function a() {};
      return {
        s: a,
        n: function n() {
          return o >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[o++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: a
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var c,
    i = !0,
    u = !1;
  return {
    s: function s() {
      _n = _n.call(t);
    },
    n: function n() {
      var e = _n.next();
      return i = e.done, e;
    },
    e: function e(_e2) {
      u = !0, c = _e2;
    },
    f: function f() {
      try {
        i || null == _n.return || _n.return();
      } finally {
        if (u) throw c;
      }
    }
  };
}
function a(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != _typeof(e) || !e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" != _typeof(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == _typeof(t) ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function c() {
  return c = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c.apply(null, arguments);
}
function i(e) {
  return i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, i(e);
}
function u(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && y(e, t);
}
function l() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (l = function l() {
    return !!e;
  })();
}
function f(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function s(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? f(Object(r), !0).forEach(function (t) {
      a(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function p(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = function (e, t) {
      if (null == e) return {};
      var r = {};
      for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
        if (t.includes(n)) continue;
        r[n] = e[n];
      }
      return r;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function y(e, t) {
  return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, y(e, t);
}
function b(e, t) {
  var r,
    n = t.replacementChars,
    a = t.replacement,
    c = t.separate,
    i = n,
    u = "",
    l = o(e);
  try {
    for (l.s(); !(r = l.n()).done;) {
      var f,
        s = r.value,
        p = !Object.prototype.hasOwnProperty.call(a, s) && (null === (f = a[i[0]]) || void 0 === f ? void 0 : f.test(s));
      (c && s === i[0] || p) && (i = i.slice(1), u += s);
    }
  } catch (e) {
    l.e(e);
  } finally {
    l.f();
  }
  return u;
}
function v(e, t) {
  var r,
    n = t.mask,
    a = t.replacement,
    c = t.separate,
    i = t.showMask,
    u = 0,
    l = "",
    f = o(n);
  try {
    for (f.s(); !(r = f.n()).done;) {
      var s = r.value;
      if (!i && void 0 === e[u]) break;
      Object.prototype.hasOwnProperty.call(a, s) && void 0 !== e[u] ? l += e[u++] : l += s;
    }
  } catch (e) {
    f.e(e);
  } finally {
    f.f();
  }
  if (c && !i) {
    for (var p = n.length - 1; p >= 0 && l[p] === n[p]; p--);
    l = l.slice(0, p + 1);
  }
  return l;
}
function m(e, t) {
  for (var r = t.mask, n = t.replacement, o = [], a = 0; a < r.length; a++) {
    var c,
      i = null !== (c = e[a]) && void 0 !== c ? c : r[a],
      u = Object.prototype.hasOwnProperty.call(n, i) ? "replacement" : void 0 !== e[a] && e[a] !== r[a] ? "input" : "mask";
    o.push({
      type: u,
      value: i,
      index: a
    });
  }
  return o;
}
function O(e) {
  return e.length > 0 ? a({}, e, /./) : {};
}
function h(e, t) {
  for (var r = t.start, n = void 0 === r ? 0 : r, o = t.end, a = t.mask, c = t.replacement, i = t.separate, u = e.slice(n, o), l = a.slice(n, o), f = "", s = 0; s < l.length; s++) {
    var p = Object.prototype.hasOwnProperty.call(c, l[s]);
    p && void 0 !== u[s] && u[s] !== l[s] ? f += u[s] : p && i && (f += l[s]);
  }
  return f;
}
function d(e, t) {
  var r = t.mask,
    n = t.replacement,
    o = "string" == typeof n ? O(n) : n,
    a = RegExp("[^".concat(Object.keys(o).join(""), "]"), "g");
  return v(b(e, {
    replacementChars: r.replace(a, ""),
    replacement: o,
    separate: !1
  }), {
    mask: r,
    replacement: o,
    separate: !1,
    showMask: !1
  });
}
function g(e, t) {
  var r = t.mask,
    n = t.replacement,
    o = "string" == typeof n ? O(n) : n,
    a = h(e, {
      mask: r,
      replacement: o,
      separate: !1
    }),
    c = RegExp("[^".concat(Object.keys(o).join(""), "]"), "g");
  return b(a, {
    replacementChars: r.replace(c, ""),
    replacement: o,
    separate: !1
  });
}
function j(e, t) {
  var r = t.mask,
    n = t.replacement,
    o = "string" == typeof n ? O(n) : n;
  return m(d(e, {
    mask: r,
    replacement: o
  }), {
    mask: r,
    replacement: o
  });
}
var w = ["[", "]", "\\", "/", "^", "$", ".", "|", "?", "*", "+", "(", ")", "{", "}"];
function P(e) {
  return w.includes(e) ? "\\".concat(e) : e;
}
function k(e, t) {
  for (var r = t.mask, n = t.replacement, o = "string" == typeof n ? O(n) : n, a = "partial" === e || "partial-inexact" === e, c = "full" === e || "partial" === e, i = "", u = 0; u < r.length; u++) {
    var l = r[u];
    0 === u && (i = "^"), a && (i += "("), i += Object.prototype.hasOwnProperty.call(o, l) ? "".concat(c ? "(?!".concat(P(l), ")") : "", "(").concat(o[l].source, ")") : P(l), u === r.length - 1 && (a && (i += ")?".repeat(r.length)), i += "$");
  }
  return i;
}
export { p as _, j as a, c as b, m as c, u as d, n as e, d as f, k as g, r as h, t as i, O as j, s as k, h as l, b as m, v as n, g as u };